import { useEffect } from "react";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";
import { Modal } from "@circle-react-uikit/ModalV2";
import { PlanSelectorVariantC } from "../../SettingsApp/Plan/PlanSettings/experiment/PlanSelectorVariantC";
import { PlansProvider } from "../../SettingsApp/Plan/RegularPlan/PlansContext";
import { ControlVariantBody } from "./ControlVariantBody";

export const PlansModalBody = () => {
  const { trackEvent } = useEventsTracker();
  const { isExperimentLayoutEnabled } = usePlanPageVariant();

  useEffect(() => {
    trackEvent("plan_settings.plans_modal.opened", {});
  }, [trackEvent]);

  return (
    <Modal.Body className="scrollbar-hide">
      <PlansProvider>
        {isExperimentLayoutEnabled ? (
          <div className="mx-auto max-w-[1080px]">
            <PlanSelectorVariantC />
          </div>
        ) : (
          <ControlVariantBody />
        )}
      </PlansProvider>
    </Modal.Body>
  );
};
